import Vue from 'vue'
import App from './App.vue'
import store from '@/store/index'
import router from '@/router/router.js'
import vConsole from 'vconsole'
import wx from 'weixin-jsapi'

import './theme/default/css/clearfix.css'
//播放器相关
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import '@/plugins/js/vantUi.js'
import '@/utils/js/resize.js'

import 'animate.css'
import '@/theme/default/css/reset.less'
import '@/theme/default/css/style.less'

// window全局配置文件
import config from '@/config/config.js'
window.config = config
Vue.use(VideoPlayer)

// 本地开发调试注入vConsole
if (window.config.isVConsole) {
  const fixsonar = new vConsole()
  fixsonar.accd = undefined
}

Vue.prototype.$wx = wx

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
